export let ZIndexLayer = /*#__PURE__*/function (ZIndexLayer) {
  ZIndexLayer[ZIndexLayer["Modal"] = 1500] = "Modal";
  ZIndexLayer[ZIndexLayer["Tooltip"] = 1700] = "Tooltip";
  return ZIndexLayer;
}({});